import R from 'ramda';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import EditClaimantPopup from '../Copyright/EditClaimantPopup';
import { getAddress, getFullName, getUnMatchedClaimants } from '../../utils';

class PublicationClaimants extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
      editClaimant: null,
    };
  }

  openEditModal(e, claimant) {
    e.preventDefault();
    this.setState({
      openModal: true,
      editClaimant: claimant,
    });
  }

  openNewModal(e) {
    e.preventDefault();
    this.setState({
      openModal: true,
      editClaimant: null,
    });
  }

  closeModal() {
    this.setState({
      openModal: false,
      editClaimant: null,
    });
  }

  updateClaimant(claimantProps) {
    const { fields } = this.props;
    const claimants = fields.claimants || [];

    if (this.state.editClaimant) {
      const index = R.findIndex(R.propEq('id', this.state.editClaimant.id))(
        claimants
      );
      if (index !== -1) {
        claimants[index] = { ...claimantProps, id: this.state.editClaimant.id };
      }
    } else {
      const lastIndex = claimants.length
        ? claimants[claimants.length - 1].id
        : 0;
      claimants.push({
        ...claimantProps,
        id: lastIndex + 1,
        newClaimant: true,
      });
    }

    this.props.assignAttribute('claimants', [...claimants]);
  }

  deleteClaimant(e, claimant) {
    const { fields } = this.props;
    const claimants = fields.claimants || [];
    const claimantName = getFullName(claimant);

    if (
      confirm(`Are you sure you want to delete the claimant "${claimantName}"?`)
    ) {
      const index = R.findIndex(R.propEq('id', claimant.id))(claimants);
      if (index !== -1) {
        claimants.splice(index, 1);
        this.props.assignAttribute('claimants', [...claimants]);
      }
    }
  }

  handleNext() {
    const { fields } = this.props;
    const claimants = fields.claimants || [];
    const authors = fields.authors || [];

    const unMatchedClaimants = getUnMatchedClaimants(authors, claimants, false);

    this.props.hideAlert();

    if (claimants.length) {
      const validates = R.filter(
        ({ firstName, lastName, organization, ...otherProps }) =>
          (organization ? !organization : !firstName) || !getAddress(otherProps)
      )(claimants);

      if (validates.length) {
        this.props.alert('error', 'Please check the required fields.');
      } else {
        if (unMatchedClaimants.length > 0) {
          this.props.router.push('/publication-reg/claimants-transfer');
        } else {
          this.props.router.push('/publication-reg/select-other-materials');
        }
      }
    } else {
      this.props.alert('error', 'Please add an claimant at least.');
    }
  }

  renderClaimants() {
    const { fields } = this.props;

    return (
      fields.claimants && (
        <div className="table-container">
          <Table>
            <thead>
              <tr>
                <th>
                  <span className="text-red">*</span>First Name
                </th>
                <th>Middle Name</th>
                <th>
                  <span className="text-red">*</span>Last Name
                </th>
                <th>Organization</th>
                <th>
                  <span className="text-red">*</span>Address
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {fields.claimants.map((claimant, i) => (
                <tr key={i}>
                  <td>{claimant.firstName}</td>
                  <td>{claimant.middleName}</td>
                  <td>{claimant.lastName}</td>
                  <td className="text-center">{claimant.organization}</td>
                  <td>{getAddress(claimant)}</td>
                  <td>
                    <span className="actions">
                      <a onClick={(e) => this.openEditModal(e, claimant)}>
                        <FontAwesome name="pencil" />
                      </a>
                      <a onClick={(e) => this.deleteClaimant(e, claimant)}>
                        <FontAwesome name="trash" />
                      </a>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )
    );
  }

  render() {
    const { editClaimant } = this.state;

    return (
      <div className="select-work">
        <Heading text="Which claimants should be listed?" />
        <div className="content">
          <p>
            <b>What is a Claimant?</b>
          </p>
          <p>
            A claimant is a person or organization that has obtained ownership
            of the copyright.
          </p>

          <p>
            <b>Claimant(s):</b>
            <br />
          </p>
          <p>
            The authors you have listed previously will also be listed as
            claimants on your copyright application. If this is incorrect,
            please add (“+add another”) or remove (<FontAwesome name="trash" />)
            the claimants below. Please provide the contact information for each
            claimant by clicking on <FontAwesome name="pencil" />.
          </p>

          {this.renderClaimants()}

          <div className="add-title-button text-right">
            <div className="add-view" onClick={(e) => this.openNewModal(e)}>
              <div className="another">+Add another</div>
            </div>
          </div>
          <br />

          <p>
            The information you provide will be used for your copyright
            application as is. Please be sure to verify that the information is
            accurate and complete now.
          </p>
          <br />

          <EditClaimantPopup
            open={this.state.openModal}
            authors={this.props.fields.authors || []}
            claimant={editClaimant}
            onSave={(claimant) => this.updateClaimant(claimant)}
            onClose={() => this.closeModal()}
          />
        </div>

        <div className="step-nav">
          <NavButtons
            direction="back"
            prev={() => this.props.router.goBack()}
          />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicationClaimants);



// WEBPACK FOOTER //
// src/components/Publication/PublicationClaimants.jsx